module.exports = __webpack_public_path__ + "assets/img/mecha-62221374.png";